import styled from 'styled-components';
import { ColStyled } from '../ColStyled';

export const ColStyledDS = styled(ColStyled)``;
